import { useEffect } from "react";

const defaultPageTitle = "ActiveCollab";

export const usePageTitle = (value, totalUpdates = 0) => {
  useEffect(() => {
    const preparePageTitle = (title) => {
      if (totalUpdates > 0) {
        title = `(${totalUpdates}) ${title}`;
      }

      return `${title} - ${defaultPageTitle}`;
    };

    if (typeof value === "string") {
      document.title = preparePageTitle(value);
    }
  }, [value, totalUpdates]);
};
